import React from 'react'
import { Container, Grid } from '@material-ui/core'
import { Stepper, Step } from '@progress/kendo-react-layout'
import { Form, FormElement } from '@progress/kendo-react-form'
import { DialogSystemGLPure, DialogPoliticyPrivacy } from '../../pures'
import { Button } from '@progress/kendo-react-buttons'
import logoGovo from '../../../assets/logos/logo_govo.legal.jpg'
import slogan from '../../../assets/logos/logo_finger_print.png'
import './register-user-invited.css'

const RegisterUserInvitedView = (props) => {
  let StepComponent = props.stepMetadata[props.selectedStep].component

  const CustomStepItem = props => {
    return (
      <Step {...props} >
        <span className='k-step-indicator'><img src={props.icon} alt='' className='item-step-icon' /></span>
        <span className='k-step-label k-step-text label-stepper '>{props.label ? props.label : props.itemSup}</span>
      </Step>
    )
  }
  return (
    <div className='user-register register-user-invited-container'>
      {/* Header of the page */}
      <div className='register-user-invited-header-layout'>
        <Grid container justify='center' alignItems='center'>
          <div className='header-regiter-person' item>
            <div className='logo-register-person'><img alt='Logo de govo.legal' className='data-logo-person-header' width='247' height='48' src={logoGovo} /></div>
            {props.logo && (
              <img alt='Logo del cliente' className='data-logo-person-header' style={{ height: '80px', padding: '0px', margin: '8px' }} src={props.logo} />
            )}
            <div className='data-akubicafirmadigital-person'><p alt='Logo de govo.legal' className='data-akubicaFirmaDigital-person-img' height='70' align='center' src={slogan} >Slogan <br /> govo.digital</p></div>

            {/* <div className='desc-register-person'><h2>{props.selectedPersonTypeName}</h2></div> */}
            {/* <div className='data-akubicafirmadigital-person'><img alt='hibou.legal Logo' className='data-akubicaFirmaDigital-person-img' width='100' height='60' src={slogan} /></div> */}
            {/* <div className='btn-close'>
            <button className='btn-close-sesion' onClick={props.onCloseSesion}><img alt='Cerrar sesión' width="30px" className='icon-close' src={CerrarSesionImage}/>Cerrar sesion</button>
          </div> */}
          </div>
        </Grid>
      </div>
      {/* Container of body and Form */}
      <div className='register-user-invited-contnet-layout' >
        <Container fixed className='container user-register-container' >
          <Container col={12}>
            <div className='steps center'>
              <Stepper value={props.selectedStep} items={props.steps} item={CustomStepItem} />
            </div>
          </Container>
          <Form
            allowSubmit={true}
            onSubmit={props.onSubmitRegisterUserInvited}
            valid={true}
            render={(formRenderProps) => (
              <Container className='form'>
                <Container className='user-register-form' spacing={4} >
                  <FormElement style={{ maxWidth: 900 }} className={'center'}>
                    <StepComponent
                      {...props}
                      validator={props.validator}
                      regex={props.regex}
                      validateInput={props.validateInput}
                      selectedPersonTypeId={props.selectedPersonTypeId}
                    />
                    <div item xs={12} lg={12} md={12} sm={12} es={12} className="register-invited-form-container-buttons" >
                      {(props.selectedStep !== 2 || (!props.enabledSMS && props.selectedStep === 1)) &&
                        <Button
                          // primary={true}
                          className='button-register-user-back'
                          onClick={(e) => props.steps[props.selectedStep] == 1 ? props.goToApp() : props.onBackStep(e)}>
                          {props.steps[props.selectedStep] == 1 ? 'cerrar' : props.steps[props.selectedStep].labelreturn}
                        </Button>
                      }
                      {props.steps[props.selectedStep] == 1 ? (
                        <Button
                          type={'submit'}
                          // primary={true}
                          style={{ marginLeft: '15px' }}
                          className='button-register-user-next'
                          onClick={!((formRenderProps.allowSubmit) || (props.selectedPlanPricing)) && props.onSubmitClick && props.goToApp()}
                        >
                          {props.steps[props.selectedStep].itemMoral ? props.steps[props.selectedStep].itemMoral : props.steps[props.selectedStep].itemSup}
                        </Button>
                      ) : (
                        <Button
                          type={'submit'}
                          //icon='save'
                          // primary={true}
                          style={{ marginLeft: '15px' }}
                          className='button-register-user-next'
                          //disabled={!((formRenderProps.allowSubmit) || (props.selectedPlanPricing))}
                          onClick={!((formRenderProps.allowSubmit) || (props.selectedPlanPricing)) && props.onSubmitClick}
                        >
                          {props.steps[props.selectedStep].itemMoral ? props.steps[props.selectedStep].itemMoral : props.steps[props.selectedStep].itemSup}
                        </Button>
                      )}
                    </div>
                  </FormElement>
                </Container>
              </Container>
            )} />

        </Container>
      </div>
      <div className='register-user-invited-footer-layout' >
        {/* Footer od the page */}
        {/* Alerts of Notification Loadign, Completed and Error */}
        <DialogSystemGLPure
          {...props}
          message={props.message}
          toggleLoadingRequesting={props.toggleLoadingRequesting}
          toggleCompletedRequesting={props.toggleCompletedRequesting}
          toggleErrorRequesting={props.toggleErrorRequesting}
        />
        <Grid container justify='center' alignItems='center'>
          <div className='footer-register-person' item>
            <div className='footer-elements'>
              <div className='footer-textR-person'><h2>Powered by A3 Cloud Microservices, S.A.P.I. de C.V.</h2></div>
              <div className='footer-textL-person'><h2 onClick={() => { props.openModalPolicityPrivacy(true) }}>Aviso de Privacidad</h2>{/*<hr class="linkHref"/>*/}</div>
            </div>
          </div>
        </Grid>
        <DialogPoliticyPrivacy
          {...props}
        />
      </div>
    </div>
  )
}
export { RegisterUserInvitedView as default }
